import { gql } from '@apollo/client';

export const GET_RATING_FOR_USER_ID = gql`
  query GetCurrentRatingForUser($userId: String!) {
    getCurrentRatingForUser(userId: $userId)
  }
`;
